import { store } from 'redux/store'
import { FoldersState } from 'redux/folders/initialState'
import { FOLDER_ITEM_TYPES } from 'types/folders'

import FolderService from 'services/folder.service'

export const dropDraggedItem = (
  droppedItems: any,
  droppedIntoFolderId: string | number,
): Promise<Partial<FoldersState>> => {
  const { selectedDecks, selectedSubfolders, rootFolder } = store.getState().folders
  const { subfolders = [], decks = [] } = rootFolder

  const draggedItemIsSelected = droppedItems.type === FOLDER_ITEM_TYPES.MASS

  // Item used if dragged item is NOT multi-selected
  const patchedItem = [
    { type: droppedItems.type, id: droppedItems.data?.id, patch: { parentFolder: droppedIntoFolderId } },
  ]

  // Multi-selected decks
  const patchedDecks = decks
    .map(deck => ({
      type: FOLDER_ITEM_TYPES.DECK,
      id: deck.id,
      patch: { parentFolder: droppedIntoFolderId },
    }))
    .filter(deck => selectedDecks[deck?.id])

  // Multi-selected subfolders
  const patchedFolders = subfolders
    .map(subfolder => ({
      type: FOLDER_ITEM_TYPES.FOLDER,
      id: subfolder.id,
      patch: { parentFolder: droppedIntoFolderId },
    }))
    .filter(subfolder => selectedSubfolders[subfolder?.id])

  const itemsToUpdate = !draggedItemIsSelected ? patchedItem : [...patchedDecks, ...patchedFolders]

  return FolderService.updateItems(itemsToUpdate)
    .then(() => FolderService.details())
    .then(rootFolder => {
      const updatedFolderState: Partial<FoldersState> = { rootFolder }

      if (draggedItemIsSelected) {
        updatedFolderState.selectedDecks = {}
        updatedFolderState.selectedSubfolders = {}
      }

      return updatedFolderState
    })
}
